import request from '@/utils/request'

// 我的投诉列表

export function getFactTsList(params) {
  return request({
    url: '/sc/ticketMain/api/factTs/page',
    method: 'get',
    headers: {
      isToken: true
    },
    params: params
  })
}
// 撤回投诉

export function deleteFactTs(data) {
  return request({
    url: '/sc/ticketMain/api/factTs/delete',
    method: 'post',
    headers: {
      isToken: true
    },
    data: data
  })
}
// 投诉统计

export function getTsztNumStatistics(params) {
  return request({
    url: '/sc/ticketMain/api/factTs/tsztNumStatistics',
    method: 'get',
    headers: {
      isToken: true
    },
    params: params
  })
}
